import { useRef, useState } from "react";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import {
  getServices,
  postActivateDeactivateService,
} from "../../../../../redux/api/admin.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { ServicesListInterface } from "../../../../../redux/interfaces/admin.interface";
import { adminRoutes } from "../../../../../router/routesConstants";

function ServicesActionButtons({
  itemId,
  crudData,
  tableContext,
}: {
  itemId: string;
  crudData: ServicesListInterface;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const isSubmitting = useRef(false);

  const { status, denumire } = crudData;

  const handleActivateOrDeactivateService = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setIsUpdatingStatus(true);

    try {
      const resultAction = await dispatch(
        postActivateDeactivateService({ idServiciu: itemId }),
      );

      if (
        checkEndpointStatus(resultAction, postActivateDeactivateService) ===
          endpointStatus.fulfilled &&
        tableContext.tablePagination.page &&
        tableContext.tablePagination.rowsPerPage
      ) {
        dispatch(
          getServices({
            page: tableContext.tablePagination.page,
            perPage: tableContext.tablePagination.rowsPerPage,
          }),
        );
      }
    } finally {
      isSubmitting.current = false;
      setIsUpdatingStatus(false);
    }
  };

  const activateDeactivateModalTitle =
    status === 1 ? "Dezactiveaza serviciu" : "Activeaza";

  const activateDeactivateModalSubtitle =
    status === 1
      ? `Doriti sa dezactivati serviciul "${denumire}"?`
      : `Doriti sa activati serviciul "${denumire}"?`;

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={denumire}
      ariaLabel={`Actiuni pentru serviciul ${denumire}`}
      items={[
        {
          id: "edit-service",
          label: "Editeaza",
          section: "manage",
          icon: "EDIT",
          tooltip: "Modifica denumirea si pretul acestui serviciu.",
          navigate: `/${adminRoutes.services}/${itemId}`,
        },
        {
          id: "toggle-service-status",
          label: status === 1 ? "Dezactiveaza" : "Activeaza",
          section: "danger",
          icon: status === 1 ? "LOCK_CLOSE" : "LOCK_OPEN",
          color: status === 1 ? "error" : "success",
          loading: isUpdatingStatus,
          tooltip:
            status === 1
              ? "Dezactiveaza serviciul dupa confirmare."
              : "Activeaza serviciul dupa confirmare.",
          withConfirmationModal: {
            modalTitle: activateDeactivateModalTitle,
            modalSubtitle: activateDeactivateModalSubtitle,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleActivateOrDeactivateService,
          },
        },
      ]}
    />
  );
}

export default ServicesActionButtons;
